import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell} from 'recharts';
import { Box, Card, Typography } from '@mui/material';

const AvgAreaPerFarmTypeChart = ({ farmTypeData }) => {
    const COLORS = ['#F9AA33', '#82ca9d', '#8884d8', '#ff7300', '#ffbb28', '#d0ed57', '#90caf9', '#4caf50'];
    
    const transformedData = farmTypeData.map(item => ({
        ...item,
        avgArea: Math.round(item.avgArea * 10) / 10  // Just round to 1 decimal place
    }));

    return (
        <Card
            sx={{
                backgroundColor: '#181F2A',
                color: '#fff',
                borderRadius: 1.5,
                p: { xs: 2, md: 3 },
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 2px 8px 0 rgba(0,0,0,0.20)',
                mb: { xs: 2, md: 2 },
                minHeight: { xs: 350, md: 400 }
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="subtitle2" sx={{ color: '#fff', fontWeight: 500, fontSize: 15, mr: 2, whiteSpace: 'nowrap' }}>
                    Average Area per Farm Type
                </Typography>
            </Box>
            <Typography sx={{ color: '#AAB4C8', fontWeight: 400, fontSize: 12, mb: 1, mt: -1 }}>
                Average area in hectares by farm type
            </Typography>
            <Box sx={{ width: '100%', flex: 1, minHeight: 320, mt: 1, height: 280 }}>
                <ResponsiveContainer width="100%" height={280}>
                    <BarChart
                        data={transformedData}
                        layout="vertical"
                        margin={{ top: 8, right: 8, left: 8, bottom: 35 }}
                        barSize={16}
                    >
                        <XAxis 
                            type="number" 
                            tick={{ fill: '#AAB4C8', fontSize: 10 }}
                            label={{ 
                                value: 'Area (ha)', 
                                position: 'insideBottom', 
                                offset: -25, 
                                fill: '#AAB4C8', 
                                fontSize: 11 
                            }}
                        />
                        <YAxis
                            dataKey="type"
                            type="category"
                            width={120}
                            interval={0}
                            tick={{ fill: '#AAB4C8', fontSize: 10 }}
                        />
                        <Tooltip 
                            formatter={(value) => [`${value} ha`, 'Average Area']}
                            contentStyle={{ 
                                backgroundColor: '#222C2F', 
                                color: '#fff', 
                                border: '1px solid #283144',
                                borderRadius: 4,
                                boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
                                fontSize: 12,
                                fontWeight: 500
                            }}
                            labelStyle={{ color: '#fff' }}
                            itemStyle={{ color: '#fff' }}
                        />
                        <Bar dataKey="avgArea" fill="#F9AA33">
                            {transformedData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </Box>
        </Card>
    );
};

export default AvgAreaPerFarmTypeChart;
